module.exports = __webpack_public_path__ + "img/avatar-bril-0.19383728.png";